<div class="dailyactivities">
    <div class="glancetitle center">
        Your Shore Excursions and Transfers
    </div>

    <div class="allactivities" *ngFor="let activityitem of shoreexcursionsInfo; let i=index;">
        <!-- <div *ngIf="!activityitem.deduper && ((activityitem.Type == 'Cruise' && activityitem.EndDate>currentdate) || activityitem.Type != 'Cruise')" -->


        <div class="excdate" *ngIf="!activityitem.priordateequal && !activityitem.deduper">
            {{activityitem.BegDate | date:'fullDate'}}</div>
        <div *ngIf="!activityitem.deduper"
            [ngClass]="{'borderaround': activityitem.expander === true,'noborderaround':activityitem.expander === false}">
            <div class="lineitem">

                <a *ngIf="!activityitem.expander" (click)="activityitem.expander = !activityitem.expander">
                    <i class="fa-solid fa-circle-plus fa-lg"></i><span class="timeslot"><span
                            class="timecollapse">{{activityitem.BegDate |
                            date:'shortTime'}} </span><span *ngIf="activityitem.Type=='Food'" class="timecollapse">
                            - {{activityitem.EndDate |
                            date:'shortTime'}}</span>
                        <span *ngIf="activityitem.Type!='Cruise'" class="activityname ">{{activityitem.Name}}</span>
                        <span *ngIf="activityitem.Type=='Cruise'" class="activityname ">Arrive
                            {{activityitem.Name}}</span>
                    </span></a>
                <a *ngIf="activityitem.expander" (click)="activityitem.expander = !activityitem.expander"><i
                        class="fa-solid fa-circle-minus fa-lg"></i><span class="timeslot"><span
                            class="timeexpand">{{activityitem.BegDate |
                            date:'shortTime'}}</span> <span *ngIf="activityitem.Type=='Food'" class="timecollapse">
                            - {{activityitem.EndDate |
                            date:'shortTime'}}</span>
                        <span *ngIf="activityitem.Type!='Cruise'"
                            class="activityname activitynameexpand">{{activityitem.Name}}</span>
                        <span *ngIf="activityitem.Type=='Cruise'" class="activityname activitynameexpand">Arrive
                            {{activityitem.Name}}</span>
                    </span></a>
            </div>
            <div class="row innerexpand" *ngIf="activityitem.expander == true">
                <div class="guestinfo" *ngIf="activityitem.GuestName!='' && activityitem.GuestName!=undefined">
                    <span class="guestname">{{activityitem.GuestName}}</span>

                </div>
                <div class="col-12">

                    <div class="activitydesc">{{activityitem.Description}}</div>


                </div>




            </div>
        </div>


            <!-- API - ItiCodes -->
            <div *ngFor="let iticodedata of iticodes; let j = index;">       
                <div *ngIf="activityitem.Name==iticodedata.ltcName && (iticodedata.locallooptoday == true || iticodedata.localloopfuture == true)">
                <!-- if the excursion name = the ltcName and the local loop is today or in the future -->
                        <div *ngIf="j==0 && iticodedata.ltcName!=''">
                            <div class="localloopbutton center">
                                <button type="button" class="btn  btn-localloop" [routerLink]="['/localloop', iticodedata.llcitiCode.slice(0, -1)+'&#37;']">View&nbsp;{{iticodedata.ltcName.split(':')[0]}}</button>
                            <!-- slice 1 character off of the llcitiCode and add a percent sign so the router link makes a good url parameter for the local loop page -->
                                <!-- split everything after the colon : in the ltcName -->
                            </div>
                        </div>
                        <div *ngIf="j>0 && iticodes[j].ltcName!=iticodes[j-1].ltcName && iticodedata.ltcName!=''">
                            <div class="localloopbutton center">
                                <button type="button" class="btn  btn-localloop" [routerLink]="['/localloop', iticodedata.llcitiCode.slice(0, -1)+'&#37;']">View&nbsp;{{iticodedata.ltcName.split(':')[0]}}</button>
                                <!-- slice 1 character off of the llcitiCode and add a percent sign so the router link makes a good url parameter for the local loop page -->
                                <!-- split everything after the colon : in the ltcName -->
                            </div>
                        </div>
                </div>
            </div> 


    </div>
</div>